import { useState } from "react";
import { saveAmountDisbursement } from "../Api/AmountDisbursement";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
//import "../Styling/AmountDisbursement.css";

const AmountDisbursement = () => {
  const [disbursementData, setDisbursementData] = useState({
    beneficiaryName: "",
    beneficiaryBankDetails: "",
    amountToBeDisbursed: "",
    modeOfPayment: "",
    dateOfDisbursement: "",
    disbursedBy: "",
    remarks: "",
    advanceReqId: ""
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setDisbursementData({ ...disbursementData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const submissionData = {
      ...disbursementData,
      createdBy: "rohity"
    };

    try {
      await saveAmountDisbursement(submissionData);
      toast.success(`🦄 Amount Disbursement Record Added Successfully`);
      setDisbursementData({
        beneficiaryName: "",
        beneficiaryBankDetails: "",
        amountToBeDisbursed: "",
        modeOfPayment: "",
        dateOfDisbursement: "",
        disbursedBy: "",
        remarks: "",
        advanceReqId: ""
      });
      navigate("/viewDisbursement");
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save disbursement"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Amount Disbursement</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Beneficiary Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="beneficiaryName"
                    value={disbursementData.beneficiaryName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Beneficiary Bank Details <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="beneficiaryBankDetails"
                    value={disbursementData.beneficiaryBankDetails}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Amount to be Disbursed <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="amountToBeDisbursed"
                    value={disbursementData.amountToBeDisbursed}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Mode of Payment <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="modeOfPayment"
                    value={disbursementData.modeOfPayment}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Disbursement <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="dateOfDisbursement"
                    value={disbursementData.dateOfDisbursement}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Disbursed By <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="disbursedBy"
                    value={disbursementData.disbursedBy}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="remarks"
                    value={disbursementData.remarks}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Advance Request ID <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="advanceReqId"
                    value={disbursementData.advanceReqId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit" disabled={loading}>
                {loading ? "Saving..." : "Save Disbursement"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default AmountDisbursement;